// @flow

export const isJp = (location: any) =>
  [
    'justpark',
    'justpark_ev',
    'enquiry',
    'driveup',
    'driveup-onstreet',
    'justpark_and_ride'
  ].indexOf(location.type) !== -1;

export const isDriveup = (location: any) =>
  ['driveup', 'driveup-onstreet'].indexOf(location.type) !== -1;

export const isReservable = (location: any) =>
  ['driveup', 'driveup-onstreet'].indexOf(location?.type) === -1;

export const isStartStop = (location: any) =>
  !!location?.facilities?.filter((facility) => facility.id === 'start_stop')
    .length;

export const hasOccupancy = (location: any) =>
  !!location.occupancyBucket && !isReservable(location);
export default {
  isJp
};
